export default {
    one: 'Τρόφιμο',
    add: 'Προσθήκη τροφίμου',
    noEditSystem: 'Δεν μπορείτε να επεξεργαστείτε τρόφιμα του συστήματος.',
    editingSystem: 'ΠΡΟΣΟΧΗ! Επεξεργάζεστε τρόφιμο συστήματος',
    name: 'Όνομα τροφίμου',
    category: 'Κατηγορία τροφίμου',
    chooseCategoryError: 'Επιλέξτε μια κατηγορία για το τρόφιμο',
    measure: 'Μονάδα μέτρησης',
    howManyGrams: 'Σε πόσα γραμμάρια αντιστοιχεί;',
    chooseType: 'Επιλογή τύπου τροφίμου',
    attributes: {
        choose: 'Επιλογή ιδιοτήτων',
        isVeganQ: 'Είναι vegan;',
        isFastingQ: 'Είναι νηστίσιμο;'
    },
    loading: 'Φορτώνει...',
    noFoods: 'Δεν υπάρχουν τρόφιμα.',
    noMoreFoods: 'Δεν υπάρχουν άλλα τρόφιμα',
    empty: {
        noMatch: 'Δεν βρέθηκαν τρόφιμα',
        list: 'Αυτή η λίστα δεν έχει τρόφιμα',
        listText: 'Διάλεξε μια άλλη λίστα από το φίλτρο «Λίστα».',
        mine: {
            title: 'Δεν έχεις δικά σου τρόφιμα ακόμα',
            subtitle: 'Τα τρόφιμα που δημιουργείς θα εμφανίζονται εδώ.'
        }
    },
    wrongQuantity: 'Παρακαλώ εισάγετε σωστή ποσότητα τροφίμου.',
    trixopoulouContent: 'Σύσταση συνταγής',
    noTrixopoulouContent: 'Δυστυχώς δεν βρέθηκε η σύσταση της συνταγής!',
    lists: {
        '0': 'Πίνακας athlisis',
        '1': 'Τριχοπούλου',
        '2': 'USDA Greece',
        '3': 'Συνταγές',
        '4': 'Τα τρόφιμά μου',
        '5': 'aCloud τρόφιμα',
        '10': 'Σούπερ μάρκετ',
        favourites: 'Αγαπημένα τρόφιμα'
    },
    servingShort: 'μερ.',
    packSizeTooltip: 'Μέγεθος συσκευασίας',
    servingSizeTooltip: 'Μερίδα σύμφωνα με την ετικέτα',
    categories: {
        fresh: 'Φρέσκιες',
        carb: 'Υδατανθρακούχες',
        fat: 'Λιπαρές',
        protein: 'Πρωτεϊνούχες',
        complex: 'Σύνθετες',
    },
    stats: {
        macros: 'Μακροθρεπτικά',
        fats: 'Λίπη',
        fresh: 'Φρέσκιες',
        amylouxes: 'Αμυλούχες',
        animal: 'Ζωϊκές',
        complex: 'Σύνθετα',
        drinks: 'Ποτά / Γενικά',
        stats: 'Στατιστικά Τροφίμων'
    },
    dbCategories: {
        fresh: 'Φρέσκιες',
        amylouxes: 'Αμυλούχες',
        fats: 'Λίπη',
        animal: 'Ζωϊκές',
        complex: 'Σύνθετα τρόφιμα',
        general: 'Ποτά / Γενικά',
        uncategorized: 'Χωρίς κατηγορία',
    },
    foodTemplates: 'Πρότυπα τροφίμων',
    freeTemplates: 'Ελεύθερα πρότυπα',
    create: 'Προσθήκη νέου τροφίμου',
    showQuantity: 'Εμφάνιση ποσοτήτων',
    hideQuantity: 'Απόκρυψη ποσοτήτων',
    stepperLegacyToggle: 'Ξεχωριστά κουμπιά +/- στα δεξιά (παλιά διάταξη)',
    foodListMacrosToggle: 'Μακροθρεπτικά στη λίστα τροφίμων',
    searchAllListsToggle: 'Αναζήτηση σε όλες τις λίστες τροφίμων',
    per: 'ανά',
    avoidedFood: 'Τρόφιμα που αποφεύγει',
    likedFood: 'Τρόφιμα που του αρέσουν',
    shortQuestionnaire: 'Σύντομο ερωτηματολόγιο',
    longQuestionnaire: 'Γενικό ερωτηματολόγιο',
    dri: 'DRI',
    dayProgress: 'Πρόοδος ημέρας',
    mealProgress: 'Πρόοδος γεύματος',
    carbohydrationWarning: 'Τα στατιστικά παρακάτω έχουν επεξεργαστεί ώστε να δημιουργηθεί η υδατανθράκωση!',
    tomatoes: 'Ντοματίνια',
    bread: 'Παξιμάδια',
    oliveOil: 'Ελαιόλαδο',
    cheese: 'Γραβιέρα',
    saturatedFatWarning: {
        exceedsLimit: 'Τα κορεσμένα λιπαρά υπερβαίνουν το συνιστώμενο όριο',
        withinLimit: 'Τα κορεσμένα λιπαρά είναι εντός του συνιστώμενου ορίου',
        percentageOfCalories: '{percentage}% των συνολικών θερμίδων',
        recommendedLimit: 'Συνιστώμενο: <10%',
        currentIntake: 'Τρέχουσα πρόσληψη: {grams}g ({kcal} kcal)'
    }
}
